module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.bill) ? _c('el-form', {
    ref: "utilityBillForm",
    attrs: {
      "model": _vm.bill,
      "rules": _vm.rules,
      "label-width": "124px"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.utilLabel) + " Bill")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 16,
      "lg": 16,
      "align": "left"
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Invoice No",
      "prop": "invoiceNo",
      "required": ""
    },
    model: {
      value: (_vm.bill.invoiceNo),
      callback: function($$v) {
        _vm.$set(_vm.bill, "invoiceNo", $$v)
      },
      expression: "bill.invoiceNo"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 4,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.adjust),
      expression: "!adjust"
    }],
    attrs: {
      "type": "warning",
      "size": "small",
      "icon": "fa fa-edit"
    },
    on: {
      "click": function($event) {
        _vm.adjust = true
      }
    }
  }, [_vm._v("Adjust")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24,
      "align": "left"
    }
  }, [_c('date-input', {
    attrs: {
      "label": "From / To",
      "type": "daterange"
    },
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "bg-lighter",
    staticStyle: {
      "padding-top": "0.5rem",
      "border-radius": "14px"
    },
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 8
    }
  }, [_c('float-input', {
    attrs: {
      "label": _vm.amountLabel,
      "prop": "amount",
      "required": ""
    },
    model: {
      value: (_vm.bill.amount),
      callback: function($$v) {
        _vm.$set(_vm.bill, "amount", $$v)
      },
      expression: "bill.amount"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 8
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Bill Date",
      "prop": "date"
    },
    model: {
      value: (_vm.bill.date),
      callback: function($$v) {
        _vm.$set(_vm.bill, "date", $$v)
      },
      expression: "bill.date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 8
    }
  }, [_c('check-box', {
    attrs: {
      "label": "Include Tax"
    },
    model: {
      value: (_vm.includeTax),
      callback: function($$v) {
        _vm.includeTax = $$v
      },
      expression: "includeTax"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "name": "billingDetailsForm2",
      "model": _vm.bill,
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [(_vm.includeTax) ? _c('el-col', {
    attrs: {
      "md": 12,
      "lg": 8
    }
  }, [(_vm.adjust) ? _c('float-input', {
    attrs: {
      "label": _vm.taxLabel + ' ' + this.formatNumber(_vm.bill.taxRate) + '%',
      "prop": "tax"
    },
    model: {
      value: (_vm.bill.tax),
      callback: function($$v) {
        _vm.$set(_vm.bill, "tax", $$v)
      },
      expression: "bill.tax"
    }
  }) : _c('el-form-item', {
    attrs: {
      "label": _vm.taxLabel + ' ' + this.formatNumber(_vm.bill.taxRate) + '%'
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.bill.tax))])]), _vm._v(" "), _c('float-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.adjust),
      expression: "adjust"
    }],
    attrs: {
      "label": "Tax Rate",
      "prop": "tax",
      "suffix": "%",
      "disabled": !_vm.adjust
    },
    model: {
      value: (_vm.bill.taxRate),
      callback: function($$v) {
        _vm.$set(_vm.bill, "taxRate", $$v)
      },
      expression: "bill.taxRate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.includeTax) ? _c('el-col', {
    attrs: {
      "md": 12,
      "lg": 8
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Non-Tax Charges",
      "prop": "untaxedCharges"
    },
    model: {
      value: (_vm.bill.untaxedCharges),
      callback: function($$v) {
        _vm.$set(_vm.bill, "untaxedCharges", $$v)
      },
      expression: "bill.untaxedCharges"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 12,
      "lg": 8
    }
  }, [_c('float-input', {
    attrs: {
      "label": _vm.overdueLabel,
      "prop": "overdue"
    },
    model: {
      value: (_vm.bill.overdue),
      callback: function($$v) {
        _vm.$set(_vm.bill, "overdue", $$v)
      },
      expression: "bill.overdue"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "md": 12,
      "lg": 8
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Penalties",
      "prop": "penalty"
    },
    model: {
      value: (_vm.bill.penalty),
      callback: function($$v) {
        _vm.$set(_vm.bill, "penalty", $$v)
      },
      expression: "bill.penalty"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 12,
      "lg": 8
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Rounding",
      "prop": "rounding"
    },
    model: {
      value: (_vm.bill.rounding),
      callback: function($$v) {
        _vm.$set(_vm.bill, "rounding", $$v)
      },
      expression: "bill.rounding"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 12,
      "lg": 8
    }
  }, [_c('float-input', {
    attrs: {
      "label": _vm.extraChargesLabel,
      "prop": "extraCharges"
    },
    model: {
      value: (_vm.bill.extraCharges),
      callback: function($$v) {
        _vm.$set(_vm.bill, "extraCharges", $$v)
      },
      expression: "bill.extraCharges"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [(_vm.includeTax) ? _c('el-col', {
    attrs: {
      "span": 23,
      "align": "right"
    }
  }, [_vm._v("\n      Sub-Total: "), _c('b', [_vm._v(_vm._s(_vm.formatNumber(this.subtotals)))])]) : _vm._e(), _vm._v(" "), (_vm.includeTax) ? _c('el-col', {
    attrs: {
      "span": 23,
      "align": "right"
    }
  }, [_vm._v("\n      Tax: "), _c('b', [_vm._v(_vm._s(_vm.formatNumber(this.taxes)))])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 23,
      "align": "right"
    }
  }, [_vm._v("\n      TOTAL: "), _c('b', [_vm._v(_vm._s(_vm.formatNumber(this.totals)))])])], 1)], 1), _vm._v(" "), (_vm.siteData && _vm.bill.total > 0) ? _c('el-row', [_c('utility-sharing-table', {
    ref: "sharingTable",
    attrs: {
      "title": "Sharing Calculation",
      "tax": _vm.includeTax,
      "row-data": _vm.bill,
      "site-id": _vm.siteData.id
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61900032"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utility/UtilityBillDetails.vue
// module id = 1523
// module chunks = 0